<template>
  <footer class="site-footer">
    <p class="site-footer__line">
      <router-link to="/terms">用户协议</router-link>
      <span class="site-footer__sep">·</span>
      <router-link to="/privacy">隐私协议</router-link>
      <span class="site-footer__sep">·</span>
      <router-link to="/extension">浏览器插件</router-link>
    </p>
    <p class="site-footer__line">
      <span>QQ:284474102</span>
      <span class="site-footer__sep">·</span>
      <span>Email:284474102@qq.com</span>
      <span class="site-footer__sep">·</span>
      <span>版权归 aiju.fun 2020-2030</span>
    </p>
  </footer>
</template>

<script setup lang="ts"></script>

<style scoped>
.site-footer {
  margin: 0;
  padding: 12px 16px 20px;
  border-top: 1px solid #ebeef5;
}

.site-footer__line {
  margin: 0;
  text-align: center;
  color: #4f5155;
  font-size: 13px;
  line-height: 1.6;
}

.site-footer__line + .site-footer__line {
  margin-top: 4px;
}

.site-footer__line a {
  color: #4f5155;
  text-decoration: none;
}

.site-footer__line a:hover {
  color: #409eff;
}

.site-footer__sep {
  margin: 0 0.5em;
  color: #c0c4cc;
}
</style>
